import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";

// import {  Vue } from "vue-class-component";
import ListViewItem from "./ListViewItem";
// @Options<UIListViewItemCheckComponent>({
//   props: {
//     item: Object,
//   },
// })

export default /*#__PURE__*/_defineComponent({
  __name: 'ui-list-view-item-check',
  props: {
	item: { type: Object },
},
  emits: ["select"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

// export default class UIListViewItemCheckComponent extends Vue {
// item: Object = {};
// параметры
// @Prop({ default: null, type: Object })
// item!: ListViewItem<any>;

function onSelect(value: any) {
	emit("select", value);
}
// getSlot() {
//   //console.log("getSlot", this.$slots);
//   return "hh";
// }
// }

return (_ctx: any,_cache: any) => {
  const _component_ui_checkbox = _resolveComponent("ui-checkbox")!

  return (_openBlock(), _createBlock(_component_ui_checkbox, {
    icon: 'icon-success',
    checked: __props.item.Selected,
    disabled: __props.item.Disabled
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(__props.item.Value)), () => [
        _createTextVNode(_toDisplayString(__props.item.Value), 1)
      ])
    ]),
    _: 3
  }, 8, ["checked", "disabled"]))
}
}

})